import React, { useEffect } from 'react';
import { SelectList } from 'components/SelectList/SelectList';
import { formatText } from 'core/i18n';
import { getCountriesListWithMainCountryOnTop } from './utils/getCountriesListWithMainCountryOnTop';

export const Nationality = ({ options, optionsActions, onChange, onOpen, onClose }) => {
    useEffect(() => {
        optionsActions.getCountries();
    }, []);

    return (
        <div className="row">
            <div className="col-sm-6">
                <SelectList
                    id="nationality"
                    profileModel="userProfile.nationality"
                    profileModelLabel="userProfile.nationalityCountryName"
                    name="country"
                    clearable={false}
                    optionsList={getCountriesListWithMainCountryOnTop(options?.get('countries')?.toJSON())}
                    autoCompleteField={false}
                    label={formatText('field-country')}
                    placeholder={formatText('field-country')}
                    validations={{
                        required: value => {
                            return value && value.length;
                        },
                    }}
                    messagesError={{ required: formatText('validation-nationalityRequired') }}
                    searchable
                    disabled={false}
                    onChange={onChange}
                    onOpen={onOpen}
                    onClose={onClose}
                />
            </div>
        </div>
    );
};
